import React from "react";
import { EsgEmissionSummaryIcon } from "assets";

export const mainTabs = {
  INITIAL_TAB: "Summary",
};

export const SITES_EMISSIONS_PAGE = {
  ABSOLUTE_PATH: "/sites-emissions",
  TITLE: "Emissions Overview",
  SIDEBAR_TITLE: "Emissions",
  ICON: <EsgEmissionSummaryIcon />,
  IS_TBD: false,
  renderMenu: false,
};